import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopyOutlined';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';

import StyledBaseListItem from '../StyledListItem';
import withShareUrl, { WithShareUrlProps } from './withShareUrl';

export type CopyLinkButtonProps = Omit<WithShareUrlProps, 'children'>;

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({
  shareUrl,
  ...rest
}) => {
  const { t } = useTranslation('social');

  const [isButtonClicked, setIsButtonClicked] = useState<boolean>(false);
  const url = React.useMemo(() => {
    return decodeURIComponent(shareUrl);
  }, [shareUrl]);

  const handleButtonClick = React.useCallback(() => {
    navigator.clipboard.writeText(url);
    setIsButtonClicked(true);
  }, [url]);

  return (
    <StyledBaseListItem
      leftIcon={<ContentCopyIcon />}
      rightIcon={isButtonClicked && <CheckIcon />}
      onClick={handleButtonClick}
      {...rest}
    >
      {isButtonClicked ? t('linkCopied') : t('copyLink')}
    </StyledBaseListItem>
  );
};

export default withShareUrl(CopyLinkButton, 'copy-link');
